import './ProjectAdmin.scss'
import ProjectAdminModel from './ProjectAdminModel'
import ProjectAdminController from './ProjectAdminController'
import PaperItem from '../../../components/Essential/PaperItem'
import { Dialog, DialogContent, DialogTitle, Grid2, IconButton, Tooltip, Typography } from '@mui/material'
import TableComponent from '../../../components/TableComponent'
import * as CONSTANTS from '../../../utils/TableColumnsConstants'
import { useTranslation } from 'react-i18next'
import { Onboarding } from '../../../components/Onboarding/Onboarding'
import { ONBOARDING_FIRST_ACCOUNT, ONBOARDING_FIRST_PROJECT } from '../../../utils/Constants'
import SplitButton from '../../../components/SplitButton'
import * as React from 'react'
import ProjectSelector from './ProjectSelector'
import CloseIcon from '@mui/icons-material/Close'
import Splash from '../../../components/Splash'


const ProjectAdminView = () => {
  const { t } = useTranslation()

  const model = ProjectAdminModel()
  const controller = ProjectAdminController(model)

  if(model.accountsLoaded!==true) {
    return <Splash />
  }

  return (
    <>
      <Dialog fullWidth  open={model.projectsDialogOpened} className='projectSelectorDialog' disableScrollLock>
        <DialogTitle variant='body1' className='title'><Tooltip title={t('tooltip.selectProject')} followCursor arrow>{t('selectProject')}</Tooltip></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={controller.handleOnboardingAddProjectClick}
          sx={(theme) => ({ position: 'absolute', right: 8, top: 8, color: theme.palette.grey[500] })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent><ProjectSelector model={model} /></DialogContent>
      </Dialog>

      {/* Check if accounts exist and are empty */}
      {model.accounts && model.accounts.length === 0 ? (
          <Onboarding data={ONBOARDING_FIRST_ACCOUNT} onClick={controller.handleOnboardingAddAccountClick} />
        ) :
        // If accounts are fine, check if projects exist and are empty
        model.projects && model.projects.length === 0 ? (
          <Onboarding data={ONBOARDING_FIRST_PROJECT} onClick={controller.handleOnboardingAddProjectClick} />
        ) : (
          // If both accounts and projects are set up, show the list of projects
          <>
          <Grid2 container spacing={2} className='container-analysis'>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <PaperItem className='boxShadow' sx={{ p: 3 }}>
                <Grid2 container justifyContent='space-between'>
                  <Grid2>
                    <Typography className='title'>{t('projects')}</Typography>
                  </Grid2>
                  <Grid2>
                    <SplitButton
                      //loading={loading}
                      onClick={controller.handleOnboardingAddProjectClick}
                      onClickAccount={controller.handleOnboardingAddAccountClick}
                    />
                  </Grid2>
                </Grid2>
              </PaperItem>
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
              <PaperItem className='boxShadow' sx={{ p: 3, height: '100%' }}>
                <TableComponent
                  className='fullHeight'
                  rowBuffer={0}
                  columnBuffer={0}
                  getRowHeight={() => 'auto'}
                  rows={model.projects}
                  loading={model.isLoading.keywordOverview}
                  columns={CONSTANTS.COLUMNS_PROJECTS_ADMIN_MANAGE(t, { model: model })}
                  paginationMode='client'
                  sortingMode='client'
                  hideFooter={model.projects.length<11}
                />
              </PaperItem>
            </Grid2>

          </Grid2>
        </>

        )}

    </>
  )
}

export default ProjectAdminView





/*
import './ProjectAdmin.scss';
import { useTranslation } from 'react-i18next';
import useProjectsManage from '../../../hooks/useProjectsManage';
import { Button, MenuItem, Typography } from '@mui/material';
import SimpleDialog from '../../../components/Dialog/Dialog';
import Selector from '../../../components/Selector/Selector';
import TableComponent from '../../../components/TableComponent';
import PaperItem from '../../../components/Essential/PaperItem';
import SplitButton from '../../../components/SplitButton/SplitButton';
import { extractRootDomain } from '../../../utils/Utils';

export const ProjectAdminView = () => {
  const { t } = useTranslation();

  const {
    error,
    loading,
    projectId,
    openModal,
    propertyId,
    dataProject,
    dataProperties,
    loadingProjects,
    COLUMNS_PROJECTS,
    connectedAccounts,
    blur,

    fetchToProperties,
    fetchCreateProjects,

    handleToggleModal,
    handleToggleProperty,
    validateCurrentsProject,
    handleOpenModalProjects,
    handleRedirectNewAccount,
  } = useProjectsManage();

  return (
    <div className="flex-col">
      <div className="manage-header">
        <h1>{t('projects')}</h1>
        <div className="manage-buttons">
          <SplitButton
            loading={loading}
            onClick={handleOpenModalProjects}
            onClickAccount={() => handleRedirectNewAccount()}
          />
        </div>
      </div>
      <PaperItem className="boxShadow" sx={{ p: 3 }}>
        <div className="data-fade-in">
          <TableComponent
            hideFooter={dataProject.length<11}
            rows={dataProject}
            loading={loadingProjects}
            disableRowSelectionOnClick
            columns={COLUMNS_PROJECTS}
            getRowHeight={() => 'auto'}
            slots={{
              noResultsOverlay: () => (
                <div className="manage-info">
                  <Typography>{error?.message}</Typography>
                </div>
              ),
              noRowsOverlay: () => (
                <div className="manage-info">
                  {error ? (
                    <Typography>{error?.message}</Typography>
                  ) : (
                    <Typography>{t('no_projects_created')}</Typography>
                  )}
                </div>
              )
            }}
            paginationMode={'client'}
            sortingMode={'client'}
          />
        </div>
      </PaperItem>

      <SimpleDialog
        open={openModal}
        onClose={() => handleToggleModal(false)}
        title={t('create_your_new_project')}>
        <div className="manage-popover">
          <Selector
            id="account"
            value={projectId}
            label={t('account')}
            placeholder={t('select_an_account_to_continue')}
            onChange={(event) => fetchToProperties(event.target.value)}>
            {connectedAccounts?.map((account) => (
              <MenuItem key={account.id} value={JSON.stringify(account)}>
                {account.name}
              </MenuItem>
            ))}
          </Selector>
          <Selector
            id="property"
            value={propertyId}
            label={t('property')}
            disabled={projectId === undefined}
            onChange={(event) => handleToggleProperty(event.target.value)}>
            {dataProperties?.map((property) => (
              <MenuItem key={property.siteUrl} value={property.siteUrl} disabled={validateCurrentsProject(property.siteUrl)}>
                <div className={'menuItem'}>
                  <div className={'domain'}>
                    <img src={`https://www.google.com/s2/favicons?sz=32&domain=${extractRootDomain(property.siteUrl)}`}
                      loading="lazy" alt="favicon" width={32} height={32} />
                    {property.siteUrl}
                  </div>
                  {validateCurrentsProject(property.siteUrl) && (
                    <div className={'error'}>{t('project_already_added')}</div>
                  )}
                </div>
              </MenuItem>
            ))}
          </Selector>

          <Button
            variant="contained"
            className="btn-manage"
            onClick={fetchCreateProjects}
            disabled={propertyId === undefined}>
            {t('add_projects')}
          </Button>
        </div>
      </SimpleDialog>
    </div>
  );
};

 */